import type { Lookups } from "../../types";
import type { FilterModule } from "../index";
import { ITSpendFilter } from "./ITSpendFilter";
import { getChips, getCount } from "./chips";
import { fromCompanyFilters, toCompanyFilters } from "./mapper";
import { defaultItSpendSlice, type ItSpendSlice } from "./slice";

export type { ItSpendSlice } from "./slice";
export { defaultItSpendSlice } from "./slice";

export const itSpendModule: FilterModule<ItSpendSlice, Lookups> = {
  key: "itSpend",
  defaultSlice: defaultItSpendSlice,
  Component: ITSpendFilter,
  getChips,
  getCount,
  toCompanyFilters,
  fromCompanyFilters,
};
